//page_cover
//-----------
if (typeof $ === 'function') {

  var scroller = $('#carousel .page_cover--carousel_thumbs'),
      thumbs = scroller.find('.page_cover--link__thumb'),
      html = $('html');

  if (thumbs.length) {

    //clicking thumbnails
    //---------------------
    thumbs.on('click', function () {
      var index = $(this).index('.page_cover--link__thumb');

      //slide carousel...
      if (typeof window.JRKIT.carousel.slideTo === 'function') {
        window.JRKIT.carousel.slideTo(index);
        window.JRKIT.carousel.pause();
      }

      //... and also open fancybox
      $('.page_cover--link__main').eq(index).trigger('click');

      return false;
    });

    //carousel thumbnails
    //--------------------
    $('#carousel .slide').on('carousel.slide.shown', function () {

      var index = $(this).index('.slide'),
          scroller = $('#carousel .page_cover--carousel_thumbs'),
          thumbs = scroller.find('.page_cover--link__thumb'),
          html = $('html');

      //highlight thumb
      thumbs
        .removeClass('current')
        .eq(index)
          .addClass('current');

      //scroll
      if (html.is('.media-lg') || html.is('.media-xl')) {
        scroller
          .scrollLeft(0)
          .animate({
            scrollTop: (thumbs.outerHeight(true) * index - 48)
          }, 500);
      } else {
        scroller
          .scrollTop(0)
          .animate({
            scrollLeft: (thumbs.outerWidth(true) * index - 64)
          }, 600);
      }
    });

  }
}
